import { FC } from 'react';

const LiveChatIcon: FC = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.0001 10C15.9916 10 9.50008 15.516 9.50008 22.32C9.50008 26.0922 11.5003 29.4639 14.6435 31.7241C14.7237 33.4444 14.4583 35.8198 12.0947 36.915C11.8785 36.9976 11.7311 37.2077 11.7308 37.44C11.7308 37.7493 11.9805 38 12.2885 38C12.3045 38 12.3205 37.9992 12.3365 37.9978C15.0513 37.9803 17.356 36.5071 18.946 34.9506C19.4501 34.4567 20.153 34.2136 20.8456 34.3447C21.8606 34.5384 22.9159 34.64 24.0001 34.64C32.0085 34.64 38.5001 29.124 38.5001 22.32C38.5001 15.516 32.0085 10 24.0001 10Z"
        fill="white"
      />
    </svg>
  );
};

export default LiveChatIcon;
